export default __webpack_public_path__ + "static/Reciclagem-cdcf87a0b99af85eaf629b07e25b7f00.svg";